// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__2KB4J","title":"AfterBackImages_title__22Y-O","images":"AfterBackImages_images__1hJUz"};